import { borderResolver } from "./auth-service-tools535.js";
import { colorResolver, textColorResolver } from "./auth-service-tools536.js";
import { fontFamilyResolver } from "./auth-service-tools537.js";
import { fontSizeResolver } from "./auth-service-tools538.js";
import { identityResolver } from "./auth-service-tools539.js";
import { lineHeightResolver } from "./auth-service-tools540.js";
import { sizeResolver } from "./auth-service-tools541.js";
import { spacingResolver } from "./auth-service-tools542.js";
const resolvers = {
  color: colorResolver,
  textColor: textColorResolver,
  fontSize: fontSizeResolver,
  spacing: spacingResolver,
  identity: identityResolver,
  size: sizeResolver,
  lineHeight: lineHeightResolver,
  fontFamily: fontFamilyResolver,
  border: borderResolver
};
export { resolvers };